export default "__VITE_ASSET__C7_DWsti__"